/* ------------------------------------------------------------------ */
/*  Chief Complaint dated-summary append (PRD.274 final rule).          */
/*                                                                      */
/*  Chief Complaint is ONE fully-editable plain-text field — NO managed */
/*  marker, NO clinician/system region split. On a new conversation's   */
/*  first successful extraction, ONE dated summary snapshot is appended  */
/*  and immediately becomes ordinary editable text. Append-once state    */
/*  is tracked OUTSIDE this string (visit_clinical_conversations         */
/*  .summary_appended_at) — never by parsing Chief Complaint text.       */
/*                                                                      */
/*  Pure + testable; no React/PowerSync.                                */
/* ------------------------------------------------------------------ */

/**
 * Append a dated summary snapshot to the current Chief Complaint text. Adds one
 * blank line before the entry when the field already has content. The result is
 * plain text with no markers. Returns the current text unchanged when the
 * summary is empty.
 */
export function appendDatedSummary(
  currentText: string | null | undefined,
  dateTime: string,
  summary: string,
): string {
  const trimmedSummary = (summary ?? '').trim();
  const cur = (currentText ?? '').replace(/\s+$/, '');
  if (!trimmedSummary) return cur;
  const entry = `${dateTime}\n${trimmedSummary}`;
  return cur ? `${cur}\n\n${entry}` : entry;
}
